import { emptyOwnerFormValue, type OwnerFormValue } from './formSchema';
import { type Owner, type OwnerMutationPayload } from './model';

const emptyToNull = (value: string) => value.trim() || null;
const trimmed = (value: string) => value.trim();

export interface OwnerPayloadOptions {
  originalTcfVendorId?: string | null | undefined;
}

export function ownerToFormValue(owner: Owner): OwnerFormValue {
  return {
    ...emptyOwnerFormValue,
    id: owner.id ?? '',
    name: owner.name,
    status: owner.status,
    businessDomain: owner.businessDomain ?? '',
    sellersJsonUrl: owner.sellersJsonUrl ?? '',
    sellersJsonStatus: owner.sellersJsonStatus,
    sellersJsonLastRefreshed: owner.sellersJsonLastRefreshed ?? '',
    sellersJsonCache: owner.sellersJsonCache ?? '',
    sellersJsonFailReason: owner.sellersJsonFailReason ?? '',
    tcfVendorId: owner.tcfVendorId ?? '',
    resellerBundleAllowlist: owner.resellerBundleAllowlist ?? '',
    billingEntity: owner.billingEntity ?? '',
    paymentCycle: owner.paymentCycle ?? '',
    billingContactEmail: owner.billingContactEmail ?? '',
    defaultSchainLogicMode: owner.defaultSchainLogicMode,
    directSchainRecords: owner.directSchainRecords,
    resellerSchainRecords: owner.resellerSchainRecords,
    adsTxtRecords: owner.adsTxtRecords,
    demandPartners: owner.demandPartners,
    connectedDemandPartners: owner.connectedDemandPartners,
  };
}

export function ownerToPayload(
  value: OwnerFormValue,
  options: OwnerPayloadOptions = {},
): OwnerMutationPayload {
  const payload: OwnerMutationPayload = {
    ...(value.id ? { id: value.id } : {}),
    name: value.name.trim(),
    status: value.status,
    businessDomain: trimmed(value.businessDomain),
    sellersJsonUrl: trimmed(value.sellersJsonUrl),
    sellersJsonStatus: value.sellersJsonStatus,
    sellersJsonLastRefreshed: emptyToNull(value.sellersJsonLastRefreshed),
    sellersJsonCache: emptyToNull(value.sellersJsonCache),
    sellersJsonFailReason: emptyToNull(value.sellersJsonFailReason),
    tcfVendorId: emptyToNull(value.tcfVendorId),
    resellerBundleAllowlist: emptyToNull(value.resellerBundleAllowlist),
    billingEntity: emptyToNull(value.billingEntity),
    paymentCycle: emptyToNull(value.paymentCycle),
    billingContactEmail: emptyToNull(value.billingContactEmail),
    defaultSchainLogicMode: value.defaultSchainLogicMode,
    directSchainRecords: value.directSchainRecords,
    resellerSchainRecords: value.resellerSchainRecords,
    adsTxtRecords: value.adsTxtRecords,
    demandPartners: value.demandPartners,
    connectedDemandPartners: value.connectedDemandPartners,
  };

  if (options.originalTcfVendorId?.trim() && !value.tcfVendorId.trim()) {
    payload.clearTcfVendorId = true;
  }

  return payload;
}
